module.exports = __webpack_public_path__ + "static/media/facebookWhite.93979a21.svg";